export default __webpack_public_path__ + "static/P_SearchThumb_InstarVision_Metro-d6eade390ec60442c7e0a59c70b8b20f.webp";